import React from 'react';
import Header from './header';
import FeaturedGuitar from './featured-guitar';
import SearchResults from '../search-results';
import GuitarFilter from './guitar-filter';
import GuitarDetail from '../guitar';

const AppPresentation = props => {
  let activeComponent = null;
  if (props.brand)
    activeComponent = (
      <SearchResults
        brand={props.brand}
        filteredGuitars={props.filteredGuitars}
        setActiveGuitar={props.setActiveGuitar}
      />
    );
  if (props.activeGuitar)
    activeComponent = <GuitarDetail guitar={props.activeGuitar} />;
  if (!activeComponent)
    activeComponent = <FeaturedGuitar guitar={props.featuredGuitar} />;

  return (
    <div className="container">
      <Header />
      <GuitarFilter brands={props.brands} filterGuitars={props.filterGuitars} />
      {activeComponent}
    </div>
  );
};

export default AppPresentation;



// WEBPACK FOOTER //
// ./src/main-page/app-presentation.js